//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      small: false,
      medium: false,
      fullWidth: false,
      fullHeight: false
    }
  }
}